import { createActions } from 'reduxsauce';
import { StripeRecurringInterval } from 'store/pay/types';

export interface UserStripeSubscriptionsState {
  data: IUserStripeSubscriptionData[];
  isLoading: boolean;
  error: string | null;
}

export interface IUserStripeSubscriptionData {
  id: string;
  name: string;
  amount?: number;
  page_name?: string;
  page_query_string?: string;
  status?: string;
  current_period_start?: number;
  current_period_end?: number;
  cancel_at_period_end: boolean;
  canceled_at?: number;
  created: number;
  metadata?: Record<string, string>;
  interval: StripeRecurringInterval;
  interval_count: number;
}

export interface UserStripeSubscriptionsTypes {
  USER_STRIPE_SUBSCRIPTIONS_START: 'USER_STRIPE_SUBSCRIPTIONS_START';
  USER_STRIPE_SUBSCRIPTIONS_SUCCESS: 'USER_STRIPE_SUBSCRIPTIONS_SUCCESS';
  USER_STRIPE_SUBSCRIPTIONS_ERROR: 'USER_STRIPE_SUBSCRIPTIONS_ERROR';
  USER_STRIPE_SUBSCRIPTIONS_CLEAN_UP: 'USER_STRIPE_SUBSCRIPTIONS_CLEAN_UP';
}

const { Types, Creators } = createActions<UserStripeSubscriptionsTypes>({
  userStripeSubscriptions: ['data'],
  userStripeSubscriptionsStart: null,
  userStripeSubscriptionsSuccess: ['data'],
  userStripeSubscriptionsError: ['error'],
  userStripeSubscriptionsCleanUp: null,
});

export { Types };

export default Creators;
